var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M40.0312 0.265625V12.3516H46.5391V18.8594H40.0312V30.5625H32.1562V0.265625H40.0312ZM40.0312 32.5312V49.9219H6.89062V32.5312H40.0312ZM14.6562 38.7109V43.6328H32.2656V38.7109H14.6562ZM29.75 4.58594V10.7656H0V4.58594H10.9375V0.046875H18.8125V4.58594H29.75ZM14.875 11.9688C22.2031 11.9688 27.3438 15.6875 27.3438 20.9922C27.3438 26.4062 22.2031 30.0703 14.875 30.125C7.49219 30.0703 2.29688 26.4062 2.35156 20.9922C2.29688 15.6875 7.49219 11.9688 14.875 11.9688ZM14.875 17.875C11.9766 17.8203 10.0078 18.8594 10.0078 20.9922C10.0078 23.2344 11.9766 24.3281 14.875 24.3281C17.8281 24.3281 19.8516 23.2344 19.8516 20.9922C19.8516 18.8594 17.8281 17.8203 14.875 17.875Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText09);
export default __webpack_public_path__ + "static/media/text09.434c308caadaa9c14f9d7e36940ddb32.svg";
export { ForwardRef as ReactComponent };